// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","content":"Footer_content__1dXVD","socials":"Footer_socials__bqeqA"};